export enum WeekDays {
  SATURDAY = 'Saturday',
  SUNDAY = 'Sunday',
  MONDAY = 'Monday',
  TUESDAY = 'Tuesday',
  WEDNESDAY = 'Wednesday',
  THURSDAY = 'Thursday',
  FRIDAY = 'Friday',
}

export interface DayOptionProps {
  title: string;
  handleChange: (dayOptions: DayOptions) => void;
}

export const weekDaysList = [
  'Saturday',
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
];

export interface DayDate {
  key: string;
  date: moment.Moment;
}

export interface NotificationBatch {
  endTime: string;
  startTime: string;
  times: number;
  sendDate: string;
  valid?: boolean;
}

export interface DayOptions {
  selected: boolean,
  startTime: string,
  endTime: string,
  timesAtDay: number,
  valid: boolean,
}

export interface NotificationBatchesProps {
  batchesChanged: (notificationBatches: NotificationBatch[]) => void;
  error: boolean;
}
